'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dispatchActions = undefined;

var _flux = require('flux');

exports.default = new _flux.Dispatcher();
var dispatchActions = exports.dispatchActions = {
    TOAST: 'REACT_TOASTR_TOAST',
    TOAST_DANGER: 'REACT_TOAST_DANGER',
    CLEAR_PREVIOUS: 'REACT_TOASTR_CLEAR_PREVIOUS'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastr-basic/lib/ToastrDispatcher.js
// module id = 118
// module chunks = 0